"use strict";
/*
 * <copyright file="HxPropertyID.ts" company="Microsoft">
 *   Copyright (c) Microsoft Corporation.  All rights reserved.
 * </copyright>
 * <summary>
 *   !!! THIS FILE IS GENERATED BY OBJECTGEN TOOL. DO NOT EDIT BY HAND. !!!
 *   PropertyIDJs.tt generates this file.
 * </summary>
 */
Object.defineProperty(exports, "__esModule", { value: true });
